export const sanitizeBaseUrl = (host: string, useHttp = false) => {
  const targetProtocol = useHttp ? 'http' : 'https'
  const value = String(host)
  if (value.startsWith('http://')) {
    return value.replace('http', targetProtocol)
  }
  if (value.startsWith('https://')) {
    return value.replace('https', targetProtocol)
  }
  if (!value.startsWith(`${targetProtocol}://`)) {
    return `${targetProtocol}://${value}`
  }
  return value
}

export const sanitizeRedirectPathToUrl = (
  redirectPath?: string,
  safeBaseUrl?: URL
): URL | undefined => {
  if (!redirectPath || !safeBaseUrl) {
    return undefined
  }
  const decodedRedirect = decodeURIComponent(redirectPath)

  let url: URL
  try {
    url = new URL(decodedRedirect, safeBaseUrl)
  } catch (e) {
    return undefined
  }

  if (url.origin === safeBaseUrl.origin) {
    return url
  }

  return undefined
}
